import React from "react";
import DrawerHeader from "@components/DrawerHeader";
import ProductRequestsScreen from "@screens/Search/ProductRequests";

const ProfileProductsRequests = (props) => {
  return (
    <>
      <DrawerHeader headerName="Requested Items" />
      <ProductRequestsScreen {...props} />
    </>
  );
};

export default ProfileProductsRequests;
